import { cn } from "@/lib/utils";

interface ImagePlaceholderProps {
  className?: string;
}

function ImagePlaceholder({ className }: ImagePlaceholderProps) {
  return (
    <div
      className={cn(
        'flex aspect-square h-auto w-40 items-center justify-center rounded border bg-gray-100 text-gray-400',
        className,
      )}
    >
      <span className="text-xs">No image</span>
    </div>
  );
}

export default ImagePlaceholder;
